import type { MenuPrivateCottages } from '../entities/MenuPrivateCottages'

export const MenuPrivateCottagesPhotos = 'photos'

const menu: MenuPrivateCottages = [
  {
    id: 'summary',
    name: 'menu.private_cottages_menu.summary',
    href: '/propietario/:ownerId/casa/:cottageId/editar/datos-basicos',
    selected: false,
  },
  {
    id: 'legal',
    name: 'menu.private_cottages_menu.legal',
    href: '/propietario/:ownerId/casa/:cottageId/legal',
    selected: false,
  },
  {
    id: 'prices',
    name: 'menu.private_cottages_menu.prices',
    href: '/propietario/:ownerId/alojamiento/:cottageId/listado/unidad-alquilable',
    selected: false,
  },
  {
    id: 'conditions',
    name: 'menu.private_cottages_menu.conditions',
    href: '/propietario/:ownerId/casa/:cottageId/editar/condiciones-reserva',
    selected: false,
  },
  {
    id: 'description',
    name: 'menu.private_cottages_menu.description',
    href: '/propietario/:ownerId/casa/:cottageId/editar/descripcion',
    selected: false,
  },
  {
    id: 'characteristics',
    name: 'menu.private_cottages_menu.characteristics',
    href: '/propietario/:ownerId/casa/:cottageId/editar/caracteristicas',
    selected: false,
  },
  {
    id: 'map',
    name: 'menu.private_cottages_menu.map',
    href: '/propietario/:ownerId/casa/:cottageId/editar/mapa',
    selected: false,
  },
  {
    id: MenuPrivateCottagesPhotos,
    name: 'menu.private_cottages_menu.photos',
    href: '/propietario/:ownerId/casa/:cottageId/editar/fotos',
    selected: false,
  },
  {
    id: 'videos',
    name: 'menu.private_cottages_menu.videos',
    href: '/propietario/:ownerId/casa/:cottageId/editar/videos',
    selected: false,
  },
]

export default menu
